import { Component, Inject } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { CommitmentSummaryItem } from '../commitment-summary-item.model';

@Component({
    selector: 'cmps-schedule-event-select-event-dialog',
    templateUrl: './select-event-dialog.component.html',
    host: {
        class: 'cmps-schedule-event-select-event-dialog',
    },
})
export class ScheduleEventSelectEventDialogComponent {
    /** @private */ _i18n = TranslationKeyMap;

    /** @private */ _selected: { [key: number]: boolean };

    /** @private */
    get _numSelected(): number {
        return Object.keys(this._selected).length;
    }

    /** @private */
    get _itemsSelected(): boolean {
        return this._numSelected !== 0;
    }

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            ScheduleEventSelectEventDialogComponent,
            any
        >,
        /** @private */ @Inject(CMPS_DIALOG_DATA)
        readonly _data: {
            checkedCommitments: CommitmentSummaryItem[];
            availableCommitmentsForUser: CommitmentSummaryItem[];
        },
    ) {
        this._selected = {};
        _data.checkedCommitments.forEach((e) => {
            const index = _data.availableCommitmentsForUser.indexOf(e);
            if (index !== -1) {
                this._selected[index] = true;
            }
        });
    }

    /** @private */
    _toggleSelect(index: number): void {
        if (this._selected[index]) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._selected[index];
        } else {
            this._selected[index] = true;
        }
    }

    /** @private */
    _onAssociateClick(): void {
        const indexes = Object.keys(this._selected).map((e) => parseInt(e));
        this._dialogRef.close(
            this._data.availableCommitmentsForUser.filter((_, ei) =>
                indexes.includes(ei),
            ),
        );
    }
}
